import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import TableDataCell from './TableDataCell';

import ImageManager from '../../../misc/ImageManager';

import FieldTypes from '../../../../constants/FieldTypes';

const StyledImageManagerWrapper = styled.div`
  height: 100%;
  padding: 2px;
`;

const TableFieldImageCell = ({

  focused,

  id,
  rowId,
  columnId,
  columnIdentifier,
  columnType,
  cellKey,
  fontColor,
  borderRadius,
  borderWidth,
  borderColor,
  backgroundColor,
  primaryColor,
  dangerColor,
  width,

  onUpload,
  onClick,
  onChange,
  onDelete,
  onFocus,
  onLoadCompleted,

  value,
  disabled,
  multi,
  enableSystemFilePicker,
  isMobileView,

  maxImageWidth,
  maxImageHeight,

}) => {

  const values = Array.isArray(value) ? value : [value];

  const [multiple, setMultiple] = useState(multi);

  useEffect(() => {
    if (Array.isArray(value) && value.length > 1) {
      setMultiple(true);
    }
  }, [value]);

  const handleUpload = useCallback((loadingCallback, errorCallback, files) => {
    onUpload(rowId, columnId, files, loadingCallback, errorCallback);
  }, [rowId, columnId]);

  const handleDelete = useCallback((i, urlObject) => {

    const nextImageValues = [...values];
    nextImageValues.splice(i, 1);

    onChange(rowId, columnId, nextImageValues);

    /**
     * Important Note: onDelete is simply to notify about the deletion event. The actual
     * removal of the image is handled by onChange.
     */
    if (onDelete) onDelete(rowId, columnId, urlObject, i);

  }, [rowId, columnId, values]);

  const handleClick = useCallback((i, urlObject) => {
    if (onClick) onClick(rowId, columnId, urlObject, i);
  }, [rowId, columnId]);

  const handleFocus = () => {

    if (onFocus) {
      onFocus(rowId, columnId, columnIdentifier, {}, columnType,);
    }

  };

  const handleLoadCompleted = useCallback(() => {
    if (onLoadCompleted) onLoadCompleted(columnId);
  }, [columnId]);

  /**
   * If the column width is less than maxImageWidth then the column width
   * will be applied as the maxImageWidth so that images would be placed within
   * cell boundary
   */
  const effectiveMaxImageWidth = maxImageWidth || 200;
  const effectiveMaxImageHeight = maxImageHeight || 200;
  const validMaxImageWidth = width && width < effectiveMaxImageWidth ? width : effectiveMaxImageWidth;

  return (
    <TableDataCell
      key={cellKey}
      data-testid={`${id}-${rowId}-${columnId}-image-cell`}
      {...{
        disabled,
        focused,
        primaryColor,
        width,
        borderColor,
        borderWidth,
        backgroundColor,
        padding: 0,
      }}
    >
      <StyledImageManagerWrapper>
        <ImageManager
          {...{
            type: FieldTypes.image, // Type is needed to only allow images for image field
            value,
            multiple: multi,
            disabled,
            isMobileView,
            enableSystemFilePicker,
            enforceMaxDimensions: true,

            maxWidth: `${validMaxImageWidth}px`,
            maxHeight: `${effectiveMaxImageHeight}px`,
            onLoadCompleted: handleLoadCompleted,
            onDelete: handleDelete,
            onFocus: handleFocus,
            onUpload: handleUpload,
            onClick: handleClick,

            primaryColor,
            dangerColor,
            fontColor,
            backgroundColor,
            borderRadius,
            borderColor,
            padding: 2, //Default spacing around images
            borderWidth: 1,
          }}
        />
      </StyledImageManagerWrapper>
    </TableDataCell>
  );
};

export default React.memo(TableFieldImageCell);
